import { Space, Typography, Row, Col, Button } from 'antd';
import { questions } from './CeoSurvey.constants';
import { CeoSurveyGeneratedProps } from './CeoSurvey.props';
import {
  Container,
  StyledTitle,
  SectionTitle,
  ButtonSpace,
} from './CeoSurvey.style';
import SurveyInput from 'components/module/SurveyInput';
import React from 'react';

const { Title } = Typography;

interface StringFunction extends Function {
  (x: string): string;
}

const optionsLabel = (index: number): StringFunction => {
  if (index == 15) {
    return x => {
      switch(x) {
        case 'Strongly Disagree':
          return 'Poor';
        case 'Disagree':
          return 'Limited';
        case 'Neutral':
          return 'About Average';
        case 'Agree':
          return 'Good but not Great';
        case 'Strongly Agree':
          return 'Excellent';
        default: return x;
      }
    }
  }

  if (index == 16) {
    return x => {
      switch(x) {
        case 'Strongly Disagree':
          return 'Seldom';
        case 'Disagree':
          return 'Annually';
        case 'Neutral':
          return 'Twice a year';
        case 'Agree':
          return 'Quaterly';
        case 'Strongly Agree':
          return 'Monthly';
        default: return x;
      }
    }
  }

  return x => x;
}


const CeoEnrollmentFormView = (props: CeoSurveyGeneratedProps): JSX.Element => {

  const showNext = false;
  const enrollmentForm = props.enrollmentForm || [];

  return (
    <Container>
      <img
        src="https://trello-attachments.s3.amazonaws.com/602532c51bd99d8afa282e34/602fb4ade48e1525bb666ac7/d3553f450bbc503227eb898472d6b3b8/Pri_A_YB%404x-100.jpg"
        alt=""
        style={{ width: '300px', backgroundRepeat: 'no-repeat' }}
      />
      <Row justify="center" style={{ paddingBottom: '80px' }}>
        <Col span={20} sm={20} md={10}>
          {/* Titles */}
          <Space direction="vertical">
            <StyledTitle>Benchmark Information</StyledTitle>
          </Space>

          {/* Questions */}
          <Space direction="vertical" size={40}>
            {enrollmentForm.filter(({question}) => question !== '')
              .map(({key, type, question}, ndx) => {
                return (<div key={key}>
                  {
                    ndx < 19 && 
                    <Title level={4}>{ndx + 1}. {question}</Title>
                  }
                  {
                    ndx > 19 && //question === 'What do customers say about your organization? What do you hope they would say?' && 
                    <Title level={4}>{ndx}. {question}</Title>
                  }

                  {
                    ndx === 18 &&
                      <>
                       <span>19 A</span>
                      </>
                  }
                  {
                    ndx === 19 &&
                      <>
                       <span>19 B</span>
                      </>
                  }

                  <SurveyInput
                    type={type}
                    onChange={(val: string) => props.onChangeInput(val, ndx)}
                    value={props.enrollmentForm[ndx].value}
                    optionsLabels={optionsLabel(ndx + 1)}
                  />
                </div>)
              })}
          </Space>

          {/* Buttons */}
          <ButtonSpace align="center">
            {showNext ? (
              <>
                <Button type="primary" size="large" onClick={props.onClickNext}>
                  Next
                </Button>{' '}
              </>
            ) : (
              <Button
                type="primary"
                size="large"
                onClick={props.onClickSubmit}
                loading={props.isSubmitting}
              >
                Submit
              </Button>
            )}
          </ButtonSpace>
        </Col>
      </Row>
    </Container>
  );
};

export default CeoEnrollmentFormView;
